/**
 * global papaLp: {
 *  locale: { [key: string]: string } 
 * }
 */

/**
 * Get the locale for the key
 * @param {string} key - The key to get the locale for
 * @returns {string} The locale for the key
 */
export function locale(key) {
    return papaLp.locale[key] || key;
}